<template>
	<v-tooltip bottom>
		<template v-slot:activator="{ on }">
			<v-btn flat icon v-on="on" @click="handleDownloadResult">
				<v-icon>mdi-download-outline</v-icon>
			</v-btn>
		</template>
		<span>Download result</span>
	</v-tooltip>
</template>
<script>
import { ACTION_NOTIFICATIONS_ERROR, STORE_NOTIFICATIONS_NAME } from '@/store_constants/notifications';
import { mapActions } from 'vuex';

export default {
	name: 'JobActionsMenu',
	props: ['job'],
	inject: ['aiService'],
	methods: {
		...mapActions(STORE_NOTIFICATIONS_NAME, {
			error: ACTION_NOTIFICATIONS_ERROR
		}),
		getUrlFromObjectKeys(obj) {
			for (const key in obj) {
				if (key.toLowerCase().includes('url')) {
					return obj[key];
				}
			}
		},
		getFileExtensionFrom(url) {
			const file = url.split('/').pop();

			return file.split('.').pop();
		},
		getMimeTypeFrom(fileExtension) {
			const mimeTypesMap = {
				mp3: 'audio/mpeg',
				mp4: 'video/mp4',
				txt: 'text/plain'
			};

			return mimeTypesMap[fileExtension];
		},
		stringToArrayBuffer(texto) {
			const encoder = new TextEncoder();

			return encoder.encode(texto).buffer;
		},
		textHandler(job) {
			const fileExtension = 'txt';
			const fileMimeType = this.getMimeTypeFrom(fileExtension);
			const fileBuffer = this.stringToArrayBuffer(JSON.stringify(job, null, 2));

			return {
				fileExtension,
				fileMimeType,
				fileBuffer
			};
		},
		async mediaContentHandler(job) {
			const aiService = this.aiService();
			const fileUrl = this.getUrlFromObjectKeys(job.response);
			const fileExtension = this.getFileExtensionFrom(fileUrl);
			const fileMimeType = this.getMimeTypeFrom(fileExtension);

			const response = await aiService.getFileBy(fileUrl);
			const fileBuffer = response.data;

			return {
				fileExtension,
				fileMimeType,
				fileBuffer
			};
		},
		getHandlerFor(jobAction) {
			const handlers = {
				SEARCH: this.textHandler,
				REWRITE_TEXT: this.textHandler,
				GENERATE_AUDIO: this.mediaContentHandler,
				GENERATE_VIDEO: this.mediaContentHandler
			};

			const handler = handlers[jobAction];
			if (!handler) throw new Error('Sorry, can not download this kind of job.');

			return handler;
		},
		async getParamsForDownloadResult() {
			const jobHandler = this.getHandlerFor(this.job.action);

			return await jobHandler(this.job);
		},
		async handleDownloadResult() {
			try {
				const { fileBuffer, fileExtension, fileMimeType } = await this.getParamsForDownloadResult();

				this.downloadResult(fileBuffer, `${this.job.id}.${fileExtension}`, fileMimeType);
			} catch (error) {
				this.error({ message: error });
			}
		},
		downloadResult(arrayBuffer, fileName, mimeType = 'application/octet-stream') {
			const blob = new Blob([arrayBuffer], { type: mimeType });

			const url = window.URL.createObjectURL(blob);

			const a = document.createElement('a');
			a.href = url;
			a.download = fileName;
			document.body.appendChild(a);
			a.click();

			document.body.removeChild(a);
			window.URL.revokeObjectURL(url);
		}
	}
};
</script>
